import { modalManagerToken } from "@/tokens";
import { reviewsIconCollectionManagerContextToken } from "@apps/reviews/context_tokens";
import ReviewsStorefrontValuesService from "@apps/reviews/services/ReviewsStorefrontValuesService";
import { reviewsIconCollectionManagerToken } from "@apps/reviews/tokens";
import { I18nModule } from "@modules/i18n/I18nModule";
import { container, injectable } from "tsyringe";

import { ModalManager } from "@components/Modal/ModalManager";
import { LoggerInterface } from "@interfaces/LoggerInterface";
import { WidgetInterface } from "@interfaces/WidgetInterface";

import LeaveReviewPageWidgetComponent from "./LeaveReviewPageWidget.svelte";
import { LeaveReviewPageWidgetConfigInterface } from "./LeaveReviewPageWidgetConfig";

@injectable()
class LeaveReviewPageWidget implements WidgetInterface {
    private readonly reviewsStorefrontValuesService: ReviewsStorefrontValuesService;
    private readonly modalManager: ModalManager;

    constructor(
        private readonly config: LeaveReviewPageWidgetConfigInterface,
        private readonly logger: LoggerInterface
    ) {
        const i18nModule = container.resolve(I18nModule);
        i18nModule.exports.i18n.registerLoader(
            "reviews.LeaveReviewPageWidget",
            i18nModule.exports.i18nApiLoaderFactory.getLoader(
                "reviews.LeaveReviewPageWidget"
            )
        );
        i18nModule.exports.i18n.registerLoader(
            "reviews.critical.LeaveReviewPageWidget",
            i18nModule.exports.i18nCriticalLoaderFactory.getLoader(
                "reviews.critical.LeaveReviewPageWidget"
            )
        );

        this.logger.debug("LeaveReviewPageWidget is initialized", config);

        this.reviewsStorefrontValuesService = container.resolve(
            ReviewsStorefrontValuesService
        );

        this.modalManager = container.resolve(modalManagerToken);
    }

    init(): this {
        const element = this.config.target;

        const contextMap = new Map();
        contextMap.set(
            reviewsIconCollectionManagerContextToken,
            container.resolve(reviewsIconCollectionManagerToken)
        );

        new LeaveReviewPageWidgetComponent({
            target:
                element.shadowRoot || element.attachShadow({ mode: "open" }),
            props: {
                reviewsStorefrontValuesService:
                    this.reviewsStorefrontValuesService,
                modalManager: this.modalManager,
            },
            context: contextMap,
        });

        return this;
    }
}

export default LeaveReviewPageWidget;
